var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component, Fragment } from "react";
import styled from "styled-components";
import padding from "@irati/ui/src/global/padding";
import { CommentEditType } from "@irati/recognition/enums/Moderation";
import NoComments from "./NoComments";
import CommentBase from "./Comment";
var Comment = styled(CommentBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), padding.tiny);
var Comments = /** @class */ (function (_super) {
    __extends(Comments, _super);
    function Comments() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            editId: "",
            editType: ""
        };
        _this.enableEditing = function (editId, editType) {
            _this.setState({
                editId: editId,
                editType: editType
            });
        };
        _this.disableEditing = function () {
            _this.setState({
                editId: "",
                editType: ""
            });
        };
        return _this;
    }
    Comments.prototype.render = function () {
        var _this = this;
        var item = this.props.item;
        var _a = this.state, editType = _a.editType, editId = _a.editId;
        return (React.createElement(Fragment, null,
            item.comments.results.map(function (comment) {
                return React.createElement(Comment, { key: comment.uuid, item: item, comment: comment, isUpdateMode: comment.uuid === editId && editType === CommentEditType.UPDATE, isDeleteMode: comment.uuid === editId && editType === CommentEditType.DELETE, isModerateMode: comment.uuid === editId && editType === CommentEditType.MODERATE, onEnableUpdateMode: _this.enableEditing, onDisableUpdateMode: _this.disableEditing, onEnableDeleteMode: _this.enableEditing, onDisableDeleteMode: _this.disableEditing, onEnableModerateMode: _this.enableEditing, onDisableModerateMode: _this.disableEditing });
            }),
            item.comments.results.length === 0 &&
                React.createElement(NoComments, null)));
    };
    return Comments;
}(Component));
export default Comments;
var templateObject_1;
